import React, { useEffect, useState } from 'react';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Auth } from 'aws-amplify';
import customStyle from './common/style/custom-style';
import Base from './components/layout/base'
import { MainRoutes } from './routers/routes';
import { LogoutRoutes } from './routers/lroutes';
import { useDispatch } from 'react-redux';
import { setGuest } from 'api/session';
import * as service from './service';
import OrganizationRoutes from 'routers/oroutes';

const THEME = createTheme(customStyle());
export const config = React.createContext();

const App = (props) => {

  const userDetails = JSON.parse(localStorage.getItem('tirefaxUserDetails'));
  const guestDetails = JSON.parse(localStorage.getItem('tirefaxGuestDetails'));
  const dispatch = useDispatch()

  useEffect(() => {
    if (guestDetails?.isAuthenticated) {
      dispatch(setGuest(guestDetails));
    }
    service.updateSessions();

  }, [guestDetails])

  var Routes = createBrowserRouter(LogoutRoutes())
  if (userDetails?.isAuthenticated) {
    if (userDetails?.role === 'sa') {
      Routes = createBrowserRouter(MainRoutes());
    } else {
      Routes = createBrowserRouter(OrganizationRoutes());
    }
  } else {
    Routes = createBrowserRouter(LogoutRoutes());
  }


  const [signIn, setSignIn] = useState({
    isAuthenticated: false,
    email: undefined,
    cognitoId: undefined,
    userType: props.configs?.userType || '',
    firstName: undefined,
    lastName: undefined,
    phone: undefined,
    orgName: undefined
  });

  const signout = () => {
    Auth.signOut({ global: true })
      .then(result => {
        setSignIn(signIn => ({ ...signIn, isAuthenticated: false, email: undefined, cognitoId: undefined, firstName: undefined, lastName: undefined, userType: undefined }));
        localStorage.removeItem('tirefaxUserDetails');

      })
      .catch(err => console.log(err));
  }

  const configs = {
    stage: props.configs?.stage || undefined,
    signIn: signIn,
    setSignIn: setSignIn,
    signout: signout,
  }

  return (
    <React.Fragment>
      <ThemeProvider theme={THEME}>
        <config.Provider value={configs}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Base>
              <React.Fragment>
                <RouterProvider router={Routes} />
              </React.Fragment>
            </Base>
          </LocalizationProvider>
        </config.Provider>
      </ThemeProvider>
    </React.Fragment>
  );
}

export default App;
